import { render, staticRenderFns } from "./EditAlternativePaymentItem.vue?vue&type=template&id=64d4ec88&"
import script from "./EditAlternativePaymentItem.vue?vue&type=script&lang=js&"
export * from "./EditAlternativePaymentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/l-setting-for-configuration-tool/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64d4ec88')) {
      api.createRecord('64d4ec88', component.options)
    } else {
      api.reload('64d4ec88', component.options)
    }
    module.hot.accept("./EditAlternativePaymentItem.vue?vue&type=template&id=64d4ec88&", function () {
      api.rerender('64d4ec88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/EditAlternativePaymentItem.vue"
export default component.exports